import clsx from 'clsx'
import { TSizeAll } from 'src/types'
import styles from './FormComponentLabelUI.module.scss'

export interface FormComponentLabelUIProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  size: TSizeAll
  required?: boolean
  /**
   * The `id` of the input element the label is bound to
   * @important Required for accessibility
   */
  htmlFor: string
}
export const FormComponentLabelUI = ({
  children,
  required,
  size,
  className,
  ...props
}: FormComponentLabelUIProps) => (
  <label className={clsx(styles.label, styles[size], className, 'form-component-label')} {...props}>
    {children} {required && '*'}
  </label>
)
